// extracted by mini-css-extract-plugin
export var emphasizeQuantity = "_ch-3";
export var flatBottomCorners = "_ch-5";
export var productImage = "_ch-0";
export var quantityContainer = "_ch-2";
export var quantityHeader = "_ch-6";
export var tooltip = "_ch-1";
export var wrapAndEllipsesOverflow = "_ch-4";